import { API_PATHS } from "./constants";

declare const REACT_APP_API_BASE_URL: string;

const API_BASE_URL = REACT_APP_API_BASE_URL;

export const config = {
  apiBaseUrl: API_BASE_URL,
  endpoints: {
    marketingData: `${API_BASE_URL}${API_PATHS.AMAZON_ADS_DATA}`,
    salesData: `${API_BASE_URL}${API_PATHS.SALES_DATA}`,
    inventory: `${API_BASE_URL}${API_PATHS.INVENTORY}`,
    productData: `${API_BASE_URL}${API_PATHS.PRODUCTS}`,
    marketWatchFilters: `${API_BASE_URL}${API_PATHS.MARKET_WATCH_FILTERS}`,
    marketWatchData: `${API_BASE_URL}${API_PATHS.MARKET_WATCH_DATA}`,
    marketWatchAnalyze: `${API_BASE_URL}${API_PATHS.MARKET_WATCH_ANALYZE}`,
    marketWatchAnalyzeProgress: `${API_BASE_URL}${API_PATHS.MARKET_WATCH_ANALYZE_PROGRESS}`,
  }
};
